import makeStyles from "@material-ui/core/styles/makeStyles"

export const useChargePersonStyle = makeStyles({
    root: {
        marginTop: 30,
    },
    button: {
        width: "70%",
        borderRadius: "30px",
        backgroundColor: "#00acc1",
        color: "white",
        "&:hover": {
            backgroundColor: "#00acc1",
        },
    },
    tooltip: {
        padding: 0,
    },
    paper: {
        width: 200,
        padding: "0 4px",
        maxHeight: 300,
        overflowY: "scroll",
    },
    menuItem: {
        borderRadius: 10,
        margin: 4,
        padding: 0,
        "&:hover": {
            backgroundColor: "#00acc1",
            color: "white",
            borderRadius: 10,
            margin: 4,
        },
    },
    subMenuItem: {
        borderRadius: 10,
        margin: 4,
        "&:hover": {
            backgroundColor: "#00acc1",
            color: "white",
            borderRadius: 10,
            margin: 4,
        },
    },
})
